import { styled } from '@mui/styles';

export const FieldsetWrapper = styled('fieldset')(({ theme }) => ({
  border: 'none',
  '&:disabled .MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.gray.light
  },
  '&:disabled .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.gray.light
  }
}));
